export const downloadKycFile = async (
  clientId: string,
  firmename: string,
  type: string,
  filename: string
) => {
  try {
    const params = new URLSearchParams({
      clientId,
      firmename,
      type,
      filename,
    })

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/files/kyc/download?${params.toString()}`,
      { method: 'GET' }
    )

    if (!response.ok) {
      const errorText = await response.text()
      console.error('File download failed:', errorText)
      return
    }

    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = filename

    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Unexpected file download error:', error)
  }
}
